module.exports = __webpack_public_path__ + "img/TC.eff341d9.svg";